/*
 * @Description:
 * @Date: 2025-07-07 13:44:05
 */
export const entpActOpenDetailTranslator = resp => {
  resp.data = {
    ...resp.data,
    fyChannel: resp.data.fyChannel || '01',
    payPassagewayCode: resp.data.payPassagewayCode || 'fyBank',
    fyBeneficiaryInfoList: resp.data.fyBeneficiaryInfoList || [],
    fyShareholderInfoList: resp.data.fyShareholderInfoList || [],
    platformAuthList: resp.data.platformAuthList || [],
    bankAuthList: resp.data.bankAuthList || [],
    electronicLedgerInformation: resp.data.electronicLedgerInformation || {}
  };
  return resp;
};
